<template>
    <div>
        <div class="row">
            <div class="col-auto">
                <div class="col-auto">
                    <!-- cerca -->
                    <search-box v-model="searchQuery.searchTerm"></search-box>
                </div>
            </div>


            <div class="col-auto"><!-- destinazione -->
                <destination-box
                v-model="searchQuery.destinazione"
                category-name="Destinazione"
                ></destination-box>
            </div>

            <div class="col-auto"><!-- provincia -->
                <province-combo v-model="searchQuery.provincia"></province-combo>
            </div>

             <div class="col-auto">
                <!-- comune -->
                <label for="select-comune">Comune</label>
                <city-combo
                v-model="searchQuery.comune"
                @city="value => searchQuery.comune = value"
                />
            </div>


            <div class="col-auto">
                <label> Azioni </label>
                <div class="btn-toolbar " role="toolbar" aria-label="Bottoni azione">
                    <div class="btn-group  mr-2" role="group" aria-label="Azioni">
                        <button class="btn mb-2 btn-primary" @click="filter()">
                            <i class="ti ti-filter"></i> Filtra
                        </button>
                        <button class="btn mb-2 btn-default" @click="noFilter()">
                            <i class="ti ti-arrow-circle-up"></i> Annulla Filtri
                        </button>
                    </div>
                     <router-link
                        tag="button"
                        type="button"
                        class="btn mb-2 btn-success"
                        :to="{ name: 'Gestione Luogo', params: {id:'new',code:$route.params.code} }" v-if="entity_create">
                        <i class="ti ti-plus"></i> Nuova Collezione
                    </router-link>
                </div>
            </div>
        </div>

        <div class="card">
            <vue-good-table
                    ref="generic-table"
                    mode="remote"
                    styleClass="vgt-table striped"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    title="Pagine"
                    :columns="columns"
                    :rows="rows"
                    totalRecords
                    :paginate="true"
                    :lineNumbers="false"
                    :pagination-options="{
                                enabled: true,
                                position: 'top',
                                nextLabel: 'Successivo',
                                prevLabel: 'Precedente',
                                rowsPerPageLabel: 'Righe per pagina',
                                dropdownAllowAll: false,
                                perPage: serverParams.pagination.currentPerPage,
                                perPageDropdown: serverParams.myPerPageDropdown,
                                setCurrentPage: serverParams.pagination.currentPage
                    }"
                    :sort-options="{ enabled: true, }"
                    :selectOptions="{
                          enabled: entity_delete,
                          selectOnCheckboxOnly: true,
                          selectionInfoClass: 'generic-class',
                          selectionText: 'righe selezionate',
                          clearSelectionText: 'deseleziona',
                    }"
                    :isLoading="isLoading"
            >
                <div slot="emptystate" id="emptystate" v-if="totalRecords == 0">
                    <div class="vgt-center-align vgt-text-disabled">
                        <span v-if="!isLoading">Nessun risultato disponibile</span>
                    </div>
                </div>

                <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                    <action-table name="Gestione Luogo" :path="table1.route"
                                  :id="props.row.id" :code="props.row.code"></action-table>
                </span>


                    <span v-else>
                    {{props.formattedRow[props.column.field]}}
                </span>
                </template>
                <!-- @deprecated: disabilitato dallo sviluppatore-->
                <div slot="selected-row-actions">
                    <a v-on:click="deleteAll()" v-if="entity_delete">
                        <p-button type="primary">Cancella Selezionati</p-button>
                    </a>
                </div>

            </vue-good-table><!-- chiusura componente -->
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    import SearchBox from "@/components/altrama/SearchBox";
    import StatusesBox from "@/components/altrama/StatusesBox";
    import StatusesSpan from "@/components/altrama/StatusesSpan";
    import ProvinceCombo from "@/components/altrama/ProvinceCombo";
    import DestinationBox from "@/components/altrama/DestinationBox";
    import CityCombo from "@/components/altrama/CityCombo";

    const tableColumns = ["Id", "Cognome", "Email"]; //mantenere per i campi tolowercase header tabella
    var tableData = [];
    var self = this;

    export default {
        components: {

            SearchBox,
            StatusesBox,
            StatusesSpan,
            ProvinceCombo,
            DestinationBox,
            CityCombo

        },
        props: ["code"],
        data() {
            return {
                table1: {
                    title: "Elenco",
                    columns: [...tableColumns],
                    data: [...tableData],
                    route: "luoghi",
                },
                columns: [
                    {
                        label: 'ID',
                        field: 'id',
                        type: 'number',
                        html: false,
                        tdClass: 'text-center',
                        thClass: 'text-center',
                    },
                    {
                        label: 'TITOLO',
                        field: 'title',
                        filterable: true,
                        sortable: false,
                    },
                     {
                        label: 'INDIRIZZO',
                        field: 'indirizzo',
                        filterable: true,
                        sortable: false,
                    },
                     {
                        label: 'COMUNE',
                        field: 'comune',
                        filterable: true,
                        sortable: false,
                    },


                    {
                        label: 'AZIONI',
                        field: 'action',
                        filterable: false,
                        html: true,
                        tdClass: 'text-center',
                        thClass: 'text-center',
                        sortable: false,
                    }
                ],
                entity_create: false,
                entity_delete: false,
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    sort: {
                        field: "id",
                        type: "desc"
                    },
                    pagination: {
                        currentPage: 1,
                        currentPerPage: 50
                    },
                    myPerPageDropdown: [10, 20, 30, 40, 50]
                },
                isLoading: false,
                searchQuery: {
                    'searchTerm': '',
                    'provincia': -1,
                    'comune': {'id': null},
                    'destinazione': {'id': null},
                },

                langs:this.$available_langs_code
            };
        },
        created: function () {

            this.code = this.$route.params.code;
            if (this.$api.user.can(this.table1.route + "-view") == false) {
                this.$router.replace("/not-found");
                return;
            }
            this.entity_create = this.$api.user.can(this.table1.route + "-create");
            this.entity_delete = this.$api.user.can(this.table1.route + "-delete");
        },
        mounted: function () {
            if (localStorage.getItem('page_searchQuery')) { // parametri di ricerca
                this.searchQuery = this.getSearchFilter();
            }
            if (localStorage.getItem('page_serverParams')) { // parametri di tabella
                this.serverParams = this.getParameterFilter();
            }
            this.updateResource();
        },

         watch: {
            code: {
                handler: function () {
                    this.noFilter();
                    location.reload();
                },
                deep: true
            }
        },

        methods: {
            filter() {
                this.serverParams.pagination.currentPage = 1;
                this.updateResource();
            },
            noFilter() {
                localStorage.removeItem("page_searchQuery");
                localStorage.removeItem("page_serverParams");

                this.serverParams = {
                    columnFilters: {},
                    sort: {
                        field: "id",
                        type: "desc"
                    },
                    pagination: {
                        currentPage: 1,
                        currentPerPage: 50
                    },
                    myPerPageDropdown: [10, 20, 30, 40, 50]
                };
                this.searchQuery = {};
                this.updateResource();
            },
            saveParameterFilter() {
                localStorage.setItem(
                    "page_searchQuery",
                    JSON.stringify(this.searchQuery)
                );
                localStorage.setItem(
                    "page_serverParams",
                    JSON.stringify(this.serverParams)
                );
            },
            saveSearchFilter() { // salva parametri di ricerca
                localStorage.setItem('page_searchQuery', JSON.stringify(this.searchQuery));
            },
            getSearchFilter() { // prende parametri di ricerca
                return JSON.parse(localStorage.getItem('page_searchQuery'));
            },
            getParameterFilter() { // prende parametri di tabella
                return JSON.parse(localStorage.getItem('page_serverParams'));
            },
            onPerPageChange(params) { // risultati per pagina
                console.log('onPerPageChange');
                console.log(params);
                this.serverParams.pagination = params;
                this.updateResource();
            },
            onPageChange(params) { // risultati nel numero di pagina della paginazione (Es: pag 2 di 5)
                console.log('onPageChange');
                console.log(params);
                this.serverParams.pagination = params;
                this.updateResource();
            },
            onSortChange(params) { // ordinamento risultati per campo
                console.log('onSortChange');
                console.log(params[0]);
                this.serverParams.sort = params[0];
                this.updateResource();
            },

            async updateResource() {
                var self = this;
                self.rows = [];
                self.isLoading = true;

                var typeSort = "+";
                if (this.serverParams.sort.type == "desc") {
                    typeSort = "-";
                }

                this.saveParameterFilter();

                await axios({
                    method: 'GET',
                    url: self.$url + this.table1.route,
                    headers: this.$config.axiosHeaders(),
                    params: {
                        code: self.code,
                        keywords: self.searchQuery.searchTerm,
                        destinazione: self.searchQuery.destinazione ? self.searchQuery.destinazione.id : -1,
                        provincia: self.searchQuery.provincia,
                        comune: self.searchQuery.comune ? self.searchQuery.comune.id : -1,
                        orderBy: typeSort + self.serverParams.sort.field,
                        page: self.serverParams.pagination.currentPage,
                        limit: self.serverParams.pagination.currentPerPage
                    }
                }).then(function (response) {

                    self.totalRecords = response.data.total;
                    self.rows = [];
                    var obj = response.data.data;

                   for( let entity of obj){
                        self.rows.push({
                            id: entity.id,
                            title: entity.nome,
                            indirizzo: entity.indirizzo,
                            comune: entity.comune,

                        });
                    }
                }).catch(function (error) {
                    self.$processError(error);

                }).finally(() => (self.isLoading = false));
            },
            deleteAll: function () {
                if (confirm('Confermare cancellazione degli elementi selezionati?')) {
                    var elenco = [];
                    var selected = this.$refs['generic-table'].selectedRows;
                    for (var i = 0; i < selected.length; i++) {
                        elenco.push(selected[i].id);
                    }
                    var self = this;
                    self.isLoading = true;

                    axios({
                        method: 'DELETE',
                        url: this.$url + this.table1.route + '/' + elenco,
                        headers: this.$config.axiosHeaders(),
                    }).then(function (response) {
                        self.$notifyVue('top', 'center', 'success', response.data.data.message, 'ti-check');
                        self.updateResource();
                    }).catch(function (error) {
                        self.$processError(error);

                    }).finally(
                        () => self.isLoading = false
                    );
                }
            },
             makeTitle(slug) {
                    var words = slug.split('_');
                    for (var i = 0; i < words.length; i++) {
                        var word = words[i];
                        words[i] = word.charAt(0).toUpperCase() + word.slice(1);
                    }
                    return words.join(' ');
            },
        } // methods
    };
</script>
